import iconMap from "./map";

const ICON_DEFAULT_CONFIG = {
  width: 16,
  height: 16,
  color: "rgb(75, 77, 79)",
};

export const findIcon = (label, iconConfig = {}) => {
  const config = Object.assign({}, ICON_DEFAULT_CONFIG, iconConfig);
  const icon = iconMap[label];
  return icon ? icon.toSvg(config) : label;
};
